import { brandExclusions } from './language-brand-exclusions';

// Define an object with all possible language constants
const ALL_LANGUAGES = {
  nlBe: 'nl-be',
  frBe: 'fr-be',
  frFr: 'fr-fr',
  nlNl: 'nl-nl',
  deDe: 'de-de',
  esEs: 'es-es',
  itIt: 'it-it',
  en: 'en',
} as const;

// Function to get filtered languages based on the brand
const getFilteredLanguages = (brandName: string | undefined): Record<string, string> => {
  if (!brandName || !brandExclusions[brandName]) {
    return ALL_LANGUAGES;
  }

  return Object.fromEntries(
    Object.entries(ALL_LANGUAGES).filter(([, value]) => !brandExclusions[brandName].includes(value)),
  );
};

// Overwrite LANGUAGES with the filtered version
export const LANGUAGES = getFilteredLanguages(process.env['NEXT_PUBLIC_BRAND_NAME']);

// Utility type to extract the values from the LANGUAGES object
type ObjectValues<T> = T[keyof T];

// Define a type for the localization language using the values from the LANGUAGES object
export type LanguageType = ObjectValues<typeof LANGUAGES>;
